import { render, staticRenderFns } from "./CarBrandModels.vue?vue&type=template&id=a5ca4584&scoped=true"
import script from "./CarBrandModels.vue?vue&type=script&lang=js"
export * from "./CarBrandModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ca4584",
  null
  
)

export default component.exports